export default {
  path: '',
  component: () => import(`@/component/admin-layout/index.vue`),
  children: [
    {
      path: '/admin/contacts',
      name: 'admin-contacts',
      component: () => import(`./index.vue`),
      meta: {
        entity_for_history_tag: {
          name: `通讯录`,
        },
        entity_list_for_breadcrumb: [
          {name: `示例功能`},
          {name: `通讯录`},
        ],
      },
    },
  ],
};

